import { render, staticRenderFns } from "./ly_instant.vue?vue&type=template&id=61ca47bf&"
import script from "./ly_instant.vue?vue&type=script&lang=js&"
export * from "./ly_instant.vue?vue&type=script&lang=js&"
import style0 from "./ly_instant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports